module.exports = __webpack_public_path__ + "media/images/logo-8acd1f67eca9d8d3f68fe43367d0cc9c.png";